module.exports = __webpack_public_path__ + "static/media/export.0fdc701d.jpg";